<template>
  <div class="points-detail">
    <!-- 积分兑换 -->
    <NavHeaderBar navBarTitle="Points Redemption" :isShowLogo="false">
    </NavHeaderBar>
    <div class="points-content">
      <div class="header-info">
        <!-- 余额 -->
        {{ $t('shared.balance') }}：<span class="money-num">{{ currentEmployee.integral }}</span>
      </div>
      <div class="gift-info">
        <van-pull-refresh v-model="refreshing" @refresh="pullDownRefreshFn">
          <van-list v-model="listLoading" :finished="finished" :finished-text="$t('tips.nothingMore')" offset="60" :immediate-check="false" @load="pullUpLoadMoreFn">
            <div class="gift-item" v-for="item in activityOrderList" :key="item.id">
              <img v-if="item.imgUrl" class="img-icon" :src="item.imgUrl.split(',')[0]" alt="" @click.stop="imgPreview(item.imgUrl)">
              <img v-else class="img-icon" src="@/assets/images/icon_noimg.png" alt="">
              <div class="item-desc">
                <div class="left-item">
                  <!-- 收入 兑换 -->
                  <div class="exchange-name">{{ [0, 3].includes(item.orderType) ? `${$t('shared.creditEarned')}-` : item.orderType === 1 ? `${$t('shared.redeemedCredit')}-` : '' }}{{ item.detailName }}</div>
                  <div class="time">{{ $t('shared.filter.time') }}：{{ item.localCreateTime }}</div>
                </div>
                <div class="right-item">{{ [0, 2, 3].includes(item.orderType) ? '+' : item.orderType === 1 ? '-' : '' }}{{ item.totalIntegral }}</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { arsActivityOrderAppListPageApi, arsActivityEmployeeInfoApi } from '@/api/home'
import { ImagePreview, Toast } from 'vant'
export default {
  data () {
    return {
      refreshing: false,
      listLoading: false,
      finished: false,
      page: 1,
      employeeId: '',
      activityOrderList: [],
      currentEmployee: {}
    }
  },
  activated () {
    this.employeeId = this.$route.query.employeeId
    this.getEmployeeInfo()
    this.pullDownRefreshFn()
  },
  methods: {
    pullDownRefreshFn () {
      this.page = 1
      this.activityOrderList = []
      this.finished = false
      this.listLoading = true
      this.getProductRecord()
    },
    getProductRecord () {
      const data = {
        page: this.page,
        limit: 10,
        employeeId: this.employeeId,
        statusList: [10]
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsActivityOrderAppListPageApi(data).then(res => {
        Toast.clear()
        if (this.page === 1) {
          this.activityOrderList = res.data.list
        } else {
          this.activityOrderList = [
            ...this.activityOrderList,
            ...res.data.list
          ]
        }
        this.listLoading = false
        this.page++
        if (this.activityOrderList.length === Number(res.data.totalRow)) {
          this.finished = true
        }
      }).catch(() => {
        this.listLoading = false
        this.finished = true
      }).finally(() => {
        // 无论成功或失败，都关闭下拉刷新的加载动画
        this.refreshing = false
      })
    },
    pullUpLoadMoreFn () {
      this.getProductRecord()
    },
    getEmployeeInfo () {
      arsActivityEmployeeInfoApi(this.employeeId).then(res => {
        this.currentEmployee = res.data
      })
    },
    imgPreview (url) {
      ImagePreview(url.split(','))
    }
  }
}
</script>

<style lang="less" scoped>
.points-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  .points-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 10px;
    .header-info {
      padding: 20px 0;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid rgba(210, 220, 236, .5);
      .money-num {
        color: #307bff;
      }
      .store-name {
        color: #333;
        margin-bottom: 6px;
      }
      .store-type {
        padding: 2px 5px;
        border: 1px solid #307bff;
        color: #307bff;
        background-color: #fff;
      }
      .point-num {
        font-weight: bold;
        font-size: 15px;
        color: #307bff;
      }
    }
    .gift-info {
      .gift-item {
        display: flex;
        padding: 10px 0;
        .item-desc {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-left: 10px;
          .exchange-name {
            margin-bottom: 13px;
            font-size: 14px;
            font-weight: bold;
          }
          .time {
            color: #333;
            font-size: 11px;
          }
          .right-item {
            color: #307bff;
            font-size: 14px;
            font-weight: bold;
          }
        }
        .img-icon {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>
